"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BigNumber = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _numeral = _interopRequireDefault(require("numeral"));

var _index = _interopRequireDefault(require("./index.styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Number = function Number(_ref) {
  var value = _ref.value,
      format = _ref.format;
  var result = (0, _numeral.default)(value).format(format);
  result = result.replace(/[a-zA-Z]+/gm, '<span>$&</span>');
  return (0, _reactHtmlParser.default)(result);
};

var BigNumber = function BigNumber(_ref2) {
  var _ref2$number = _ref2.number,
      number = _ref2$number === void 0 ? 0 : _ref2$number,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'money' : _ref2$type;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, type === 'money' && /*#__PURE__*/_react.default.createElement(_index.default.BigNumber, null, /*#__PURE__*/_react.default.createElement("span", null, "$"), /*#__PURE__*/_react.default.createElement(Number, {
    value: number,
    format: "0.0a"
  })), type === 'percentage' && /*#__PURE__*/_react.default.createElement(_index.default.Percentage, null, /*#__PURE__*/_react.default.createElement(Number, {
    value: number,
    format: "0.0a"
  }), /*#__PURE__*/_react.default.createElement("span", null, "%")));
};

exports.BigNumber = BigNumber;
BigNumber.propTypes = {
  number: _propTypes.default.number,
  type: _propTypes.default.string
};